export const STORAGE_NAME = 'pronto'
export const VERSION = 'version'
export const AUTH = 'auth'
export const FILTERS = 'filters'
export const CONFIG = 'config'

// Stored separately from the store:
export const HAS_ACCEPTED_COOKIES = 'HAS_ACCEPTED_COOKIES'
